
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-975891ea&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SwitchControll.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SwitchControll.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-975891ea!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SwitchControll.vue"),
  /* scopeId */
  "data-v-975891ea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/SwitchControll.vue
// module id = 915
// module chunks = 2